import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const inserirAplicacao = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.post('/aplicativos/inserir', params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const editarAplicativo = async (id: number, params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/aplicativos/editar/${id}`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const listarAvisoNecessidadeAtuacao = async (page: number, seqExecutor: number, size: number) => {
  try {
    const response = await api.get(`/pendencias/listar?pagina=${page}&seqExecutor=${seqExecutor}&tamanhoPagina=${size}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const avisoPublicacoesRejeitadas = async (page: number, seqExecutor: number, size: number) => {
  try {
    const response = await api.get(`/pendencias/rejeitadas?pagina=${page}&seqSolicitor=${seqExecutor}&tamanhoPagina=${size}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const obterAvisoNecessidadeAtuacao = async (id: number) => {
  try {
    const response = await api.get(`/pendencias/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter aplicativo';
    throw new Error(errorMessage);
  }
};